import { render, staticRenderFns } from "./ResistantStarchSection.vue?vue&type=template&id=51b4d962&scoped=true&"
import script from "./ResistantStarchSection.vue?vue&type=script&lang=js&"
export * from "./ResistantStarchSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4d962",
  null
  
)

export default component.exports